import ApiHttp from '../http';
import Observable from '../util/observable'
import User from '../model/User'

const TOKEN_KEY = 'sk-session-info';
const STORED_ORDER_USER = 'sk-session-user-info';

export const AUTH_CHANGED = 'AUTH_CHANGED';
export const TOKEN_CHANGED = 'TOKEN_CHANGED';
export const PROFILE_CHANGED = 'UserProfileChanged';

class AuthService extends Observable {

    get PROFILE_CHANGED() {
        return PROFILE_CHANGED;
    }

    constructor() {
        super();
        this._token = null;
        this._userPromise = null;
        this._user = null;
        this.orderUser = null;
        this._tokenRefreshInProgress = false;
        this._cachedTokenPromise = null;
        this._tokenRequestUri = '/member/session';
        this._rewards_promise = null;
        this.firstLogin = false;

    }

    authToken() {
        if (!this._token) {
            try {
                this._token = JSON.parse(localStorage.getItem(TOKEN_KEY));
            }
            catch (e) {
                console.info("authToken: Failed to retrieve token from local storage", e);
                // do nothing.
            }
        }
        return this._token;
    }

    retrieveAuthToken() {
        //todo:
        if (this._cachedTokenPromise) return this._cachedTokenPromise;

        // console.info('refresh token requested accepted...',);
        this._cachedTokenPromise = ApiHttp.get(this._tokenRequestUri);
        this._cachedTokenPromise.then(r=> {
            if (r.data && r.data.session_token) {
                // console.info('token retrieved!');
                this._processTokenRetrievedResponse(r);
            }
        });

        return this._cachedTokenPromise;
    }

    _processTokenRetrievedResponse(r) {
        if (r.data.session_token) {
            this._setToken(r.data.session_token);
            this.notifyObservers(TOKEN_CHANGED);
        }
    }

    _setToken(token) {
        this._token = token;
        try {
            localStorage.setItem(TOKEN_KEY, JSON.stringify(this._token));
        } catch (e) {
            // console.log('localStorage not available')
        }
    }

    updateUser(user) {
        // console.log("User to be Updated", user);
        this._userPromise = undefined;
        return this._userPromise = ApiHttp.put(`/member`, user)
            .then(
                (response)=> {
                    // this.notifyObservers("UserProfileChanged");
                    return new User(response.data)
                },
                (error)=> {
                    this._userPromise = undefined;
                    return Promise.reject(error);
                }
            )
    }

    updateUserCards(cardsList) {
        return ApiHttp.put(`/member/cards`, cardsList)
            .then(
                (response)=> {
                    return response.data;
                },
                (error)=> {
                    this._userPromise = undefined;
                    return Promise.reject(error);
                }
            )
    }

    signUp(user) {
        if (!user instanceof User) throw Error("Signup Requires a valid user instance.");
        return this._userPromise = ApiHttp.post(`/member`, user)
            .then(
                (response)=> {
                    var token = response.request.getResponseHeader("X-SET-SESSION");
                    if (token)
                        this._setToken(token);

                    this.notifyObservers("UserProfileChanged");
                    // return response.data
                    return new User(response.data)
                },
                (error)=> {
                    this._userPromise = undefined;
                    return Promise.reject(error);
                }
            )
    }

    signIn(Email, Password) {
        return this._userPromise = ApiHttp.post(`/member/sign-in`, {
            Email,
            Password
        }).then(
            (response)=> {
                var token = response.request.getResponseHeader("X-SET-SESSION");
                if (token) {
                    this._setToken(token);
                    this.notifyObservers(PROFILE_CHANGED);
                }
                // console.log(response.data)
                // return new User(response.data)

            },
            (error)=> {
                localStorage.removeItem('sk-session-info');
                var token = error.request.getResponseHeader("X-SET-SESSION");
                if (token) {
                    this._setToken(token);
                    Promise.resolve(new User()).then((user) => {
                        this.signOut();
                        // console.log("error user obj",user);
                        return user;    
                    })
                }

                this._userPromise = undefined
                return Promise.reject(error);
            }
        )
    }

    user() {
        return this._userPromise = this._userPromise || ApiHttp.get(`/member`)
                .then(
                    (response)=> {
                        // this.notifyObservers("UserProfileLoaded");
                        // console.log("user response", response)
                        let user = new User(response.data)
                        // console.log("promise user", user)

                        let memberId = "Guest"
                        if(user.MemberId != null) {
                            memberId = user.MemberId
                        }
                        // _gaq.push(['_setCustomVar', 1, 'UserId', user.MemberId]);
                        dataLayer.push({
                            'event': 'login',
                            'userID': memberId
                        });
                        // dataLayer.push({'UserId': user.MemberId})
                        return user
                    },
                    (error)=> {
                        if (error.request) {
                            // console.log("user error", error)
                            var token = error.request.getResponseHeader("X-SET-SESSION");
                            if (token) {
                                this._setToken(token);
                                Promise.resolve(new User()).then((user) => {
                                    // console.log("error user obj",user);
                                    this.signOut();

                                    let memberId = "Guest"
                                    if(user.MemberId != null) {
                                        memberId = user.MemberId
                                    }
                                    dataLayer.push({
                                        'event': 'login',
                                        'userID': memberId
                                    });
                                    return user;    
                                })
                            }
                        }
                        this._userPromise = undefined;
                        dataLayer.push({
                            'event': 'login',
                            'userID': "Guest"
                        });
                        // console.log("user no error.request", error)
                        return Promise.reject(error);
                    }
                )
        // console.log("userPromise",this._userPromise)
        // 
        // return this._userPromise
    }

    getRewards() {
        return this._rewards_promise = this._rewards_promise || ApiHttp.get(`/member/rewards`).then((resp)=>resp.data,
                (error)=> {
                    if (error.request) {
                        var token = error.request.getResponseHeader("X-SET-SESSION");
                        if (token) {
                            this._setToken(token);
                            return Promise.resolve(new User());
                        }
                    }
                    this._userPromise = undefined;
                    return Promise.reject(error);
                });
    }

    isGuestUser() {
        return this.user().then((user)=>user.isGuest(), ()=>true);
    }

    _getLocalUserOrderInfo() {
        if (!this.orderUser) {
            try {
                //todo check if sessionEXPIRED

                this.orderUser = JSON.parse(localStorage.getItem("ORDER_USER_TEMP") || localStorage.getItem("ORDER_USER"));
                this.orderUser.fromUser = false;
            }
            catch (e) {
            }
        }
        return this.orderUser;
    }

    getUserOrderInfo() {
        return this.user().then((user)=> {
            //todo if the user is a guest, attempt to retrieve any info about the user from local storage;
            //todo otherwise get the user data relevant to an order.
            if (!user.isGuest() && !this._getLocalUserOrderInfo()) {
                return {
                    FullName: user.FullName,
                    MobilePhone: user.MobilePhone,
                    Email: user.Email,
                    fromUser: true,
                    isTemp: false,
                }
            } else {
                return this._getLocalUserOrderInfo()
            }
            return {}
        })

    }

    storeLocalUserOrderInfo(orderUser, temp = false) {
        // todo - used to store firstname,cell and email for a guest user:
        if (!orderUser) return;
        this.orderUser = {
            FullName: orderUser.FullName,
            LastName: orderUser.LastName,
            Email: orderUser.Email,
            MobilePhone: orderUser.MobilePhone,
            isTemp: temp
        };
        try {
            localStorage.setItem(temp ? "ORDER_USER_TEMP" : "ORDER_USER", JSON.stringify(orderUser));
        } catch (e) {
            console.log('localStorage not available')
        }
    }

    clearTempLocalUserOrderInfo() {

        try {
            localStorage.removeItem('ORDER_USER_TEMP');
        } catch (e) {
        }
    }

    signOut() {
        localStorage.removeItem('sk-session-info');
        this._token = null;
        this._userPromise = null;
        this.notifyObservers("UserProfileChanged");
    }

    subscribeToNewsletter(email){
        return ApiHttp.post('/member/subscribe',{email});
    }

    initiatePasswordReset(email) {
        return ApiHttp.post(`/member/initiate-password-reset`, {Email: email}).then(
                (result) => {
                    return result
                },
                (error) => {
                    return Promise.reject(error)
                }
            )
    }

    validateResetCode(resetCode = false) {
        if(resetCode) {
            return ApiHttp.post(`/member/validate-password-reset`, {resetCode: resetCode}).then(
                (result) => {
                    return result
                },
                (error) => {
                    return Promise.reject(error)
                }
            )
        } else {
            return false
        }
    }

    completePasswordReset(newPassword, resetCode, memberId) {
        if(resetCode && newPassword) {
            return ApiHttp.post(`/member/complete-password-reset`, {resetCode: resetCode, newPassword: newPassword, MemberId: memberId}).then(
                (result) => {
                    return result
                },
                (error) => {
                    return Promise.reject(error)
                }
            )
        } else {
            return false
        }
    }

    facebookSignUp(fbObject) {
        return this._userPromise = ApiHttp.post(`/member/facebook-signup`, fbObject).then(
                (response) => {
                    var token = response.request.getResponseHeader("X-SET-SESSION");
                    if (token) {
                        this._setToken(token);
                        this.notifyObservers(PROFILE_CHANGED);
                    }
                    return new User(response.data)
                },
                (error) => {
                    return Promise.reject(error)
                }
            )
    }

    initiateEmailChange(email, memberid) {
        return ApiHttp.post(`/member/initiate-email-change`, {Email: email, MemberId: memberid}).then(
                (result) => {
                    return result
                },
                (error) => {
                    return Promise.reject(error)
                }
            )
    }

    validateChangeEmail(validateCode) {
        return ApiHttp.post(`/member/validate-email-change`, {validateCode: validateCode}).then(
                (result) => {
                    return result
                },
                (error) => {
                    return Promise.reject(error)
                }
            )
    }

    resendActivation(){
        return ApiHttp.get(`/member/resend-activation`)
    }

    activateMember(activationCode) {
        return ApiHttp.post(`/member/activate`, {activationCode}).then(
                (response) => {
                    return response.data
                },
                (error) => {
                    return Promise.reject(error)
                }
            )
    }

    replaceCard(CardNumber) {
        return ApiHttp.post(`/member/next-card`, {CardNumber: CardNumber}).then(
            (response) => {
                return response.data
            }
        )
    }
}

export default new AuthService();


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/service/auth-service.js